import React, { createContext, useContext, useState, useCallback } from "react";
import { apiPost } from "./api";

const TOKEN_KEY = "algonest_token";
const EMAIL_KEY = "algonest_email";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => window.localStorage.getItem(TOKEN_KEY) || null);
  const [email, setEmail] = useState(() => window.localStorage.getItem(EMAIL_KEY) || null);

  const persist = useCallback((tok, mail) => {
    if (tok) {
      window.localStorage.setItem(TOKEN_KEY, tok);
      window.localStorage.setItem(EMAIL_KEY, mail || "");
    } else {
      window.localStorage.removeItem(TOKEN_KEY);
      window.localStorage.removeItem(EMAIL_KEY);
    }
    setToken(tok || null);
    setEmail(mail || null);
  }, []);

  const login = useCallback(
    async (mail, password) => {
      const r = await apiPost("/login", { email: mail, password });
      persist(r.token, r.email);
      return r;
    },
    [persist]
  );

  const register = useCallback(
    async (mail, password) => {
      const r = await apiPost("/register", { email: mail, password });
      persist(r.token, r.email);
      return r;
    },
    [persist]
  );

  const logout = useCallback(() => persist(null, null), [persist]);

  const value = { token, email, isAuthed: !!token, login, register, logout };
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

// Falls back to a logged-out stub so components never crash if rendered
// outside a provider (e.g. isolated unit tests).
export function useAuth() {
  return (
    useContext(AuthContext) || {
      token: null,
      email: null,
      isAuthed: false,
      login: async () => {},
      register: async () => {},
      logout: () => {},
    }
  );
}
